import React from 'react';

export const getStatusBadge = (status) => {
  switch (status) {
    case 'AWARDED':
      return <span className="badge badge-warning">Awarded</span>;
    case 'PRINTED':
      return <span className="badge badge-info">Marked as Printed</span>;
    case 'DELIVERED':
      return <span className="badge badge-success">Delivered</span>;
    default:
      return <span className="badge badge-secondary">{status}</span>;
  }
};

export const getTypeText = (type) => {
  switch (type) {
    case 'LEVEL_COMPLETION':
      return 'Level Completion';
    case 'SPECIAL_ACHIEVEMENT':
      return 'Special Achievement';
    case 'PARTICIPATION':
      return 'Participation';
    default:
      return type;
  }
};

// What a certificate is for: a level, or the title of any other award.
export function certificateLabel(certificate) {
  if (certificate.level) return `Level ${certificate.level.identifier}: ${certificate.level.name}`;
  return certificate.title || 'Certificate';
}

export function certificateShortLabel(certificate) {
  if (certificate.level) return `Level ${certificate.level.identifier}`;
  return certificate.title || 'Certificate';
}

export function certificateFilename(certificate) {
  const parts = [certificate.gymnast?.firstName || 'gymnast', certificate.gymnast?.lastName || 'name', certificateShortLabel(certificate)];
  return `certificate-${parts.join('-').replace(/[^\w-]+/g, '-')}.png`;
}
